// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/fun-at-the-park.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const funAtThePark: Score = {
  slug: "fun-at-the-park",
  n: 15,
  title: "Fun at the Park",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 88,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 16,
  barQuarters: 4.0,
  lowest: 41,
  highest: 74,
  hasLyrics: false,
  jasonNote: "Play this one at a steady pace and have fun with the trill. Use a lot of dynamics to add another level of contrast to your music",
  teaches: ["the trill ornament", "dynamic contrast", "keeping a steady pace"],
  art: "/sight-reading/art/fun-at-the-park.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/fun-at-the-park.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 1, hand: "lh", start: 0.0, dur: 2.0, midi: 48, pitch: "C3", d: "half" },
    { bar: 1, hand: "rh", start: 2.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 1, hand: "lh", start: 2.0, dur: 2.0, midi: 47, pitch: "B2", d: "half" },
    { bar: 2, hand: "rh", start: 4.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
    { bar: 2, hand: "lh", start: 4.0, dur: 4.0, midi: 45, pitch: "A2", d: "whole" },
    { bar: 3, hand: "rh", start: 8.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 3, hand: "lh", start: 8.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 3, hand: "lh", start: 10.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 3.0, midi: 67, pitch: "G4", d: "half", dot: true },
    { bar: 4, hand: "lh", start: 12.0, dur: 4.0, midi: 52, pitch: "E3", d: "whole" },
    { bar: 4, hand: "rh", start: 15.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.5, midi: 69, pitch: "A4", d: "quarter", dot: true },
    { bar: 5, hand: "lh", start: 16.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 5, hand: "rh", start: 17.5, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 5, hand: "rh", start: 18.0, dur: 2.0, midi: 62, pitch: "D4", d: "half" },
    { bar: 5, hand: "lh", start: 18.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.5, midi: 67, pitch: "G4", d: "quarter", dot: true },
    { bar: 6, hand: "lh", start: 20.0, dur: 2.0, midi: 52, pitch: "E3", d: "half" },
    { bar: 6, hand: "rh", start: 21.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 60, pitch: "C4", d: "half" },
    { bar: 6, hand: "lh", start: 22.0, dur: 2.0, midi: 45, pitch: "A2", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.5, midi: 65, pitch: "F4", d: "quarter", dot: true },
    { bar: 7, hand: "lh", start: 24.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.5, midi: 59, pitch: "B3", d: "quarter", dot: true },
    { bar: 7, hand: "lh", start: 26.0, dur: 2.0, midi: 43, pitch: "G2", d: "half" },
    { bar: 7, hand: "rh", start: 27.5, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 0.5, midi: 60, pitch: "C4", d: "eighth" },
    { bar: 8, hand: "lh", start: 28.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole" },
    { bar: 8, hand: "rh", start: 28.5, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 8, hand: "rh", start: 29.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 8, hand: "rh", start: 29.5, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 8, hand: "rh", start: 30.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth" },
    { bar: 8, hand: "rh", start: 30.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 8, hand: "rh", start: 31.0, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 8, hand: "rh", start: 31.5, dur: 0.5, midi: 72, pitch: "C5", d: "eighth" },
    { bar: 9, hand: "rh", start: 32.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 9, hand: "lh", start: 32.0, dur: 2.0, midi: 48, pitch: "C3", d: "half" },
    { bar: 9, hand: "rh", start: 34.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 9, hand: "lh", start: 34.0, dur: 2.0, midi: 47, pitch: "B2", d: "half" },
    { bar: 10, hand: "rh", start: 36.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
    { bar: 10, hand: "lh", start: 36.0, dur: 4.0, midi: 45, pitch: "A2", d: "whole" },
    { bar: 11, hand: "rh", start: 40.0, dur: 1.5, midi: 72, pitch: "C5", d: "quarter", dot: true },
    { bar: 11, hand: "lh", start: 40.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 11, hand: "rh", start: 41.5, dur: 0.25, midi: 74, pitch: "D5", d: "16th" },
    { bar: 11, hand: "rh", start: 41.75, dur: 0.25, midi: 72, pitch: "C5", d: "16th" },
    { bar: 11, hand: "rh", start: 42.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 11, hand: "lh", start: 42.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 11, hand: "rh", start: 43.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 12, hand: "rh", start: 44.0, dur: 3.0, midi: 67, pitch: "G4", d: "half", dot: true },
    { bar: 12, hand: "lh", start: 44.0, dur: 4.0, midi: 52, pitch: "E3", d: "whole" },
    { bar: 12, hand: "rh", start: 47.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 13, hand: "rh", start: 48.0, dur: 1.5, midi: 69, pitch: "A4", d: "quarter", dot: true },
    { bar: 13, hand: "lh", start: 48.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 13, hand: "rh", start: 49.5, dur: 0.5, midi: 65, pitch: "F4", d: "eighth" },
    { bar: 13, hand: "rh", start: 50.0, dur: 2.0, midi: 62, pitch: "D4", d: "half" },
    { bar: 13, hand: "lh", start: 50.0, dur: 2.0, midi: 43, pitch: "G2", d: "half" },
    { bar: 14, hand: "rh", start: 52.0, dur: 1.5, midi: 67, pitch: "G4", d: "quarter", dot: true },
    { bar: 14, hand: "lh", start: 52.0, dur: 2.0, midi: 52, pitch: "E3", d: "half" },
    { bar: 14, hand: "rh", start: 53.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 14, hand: "rh", start: 54.0, dur: 1.5, midi: 60, pitch: "C4", d: "quarter", dot: true },
    { bar: 14, hand: "lh", start: 54.0, dur: 2.0, midi: 45, pitch: "A2", d: "half" },
    { bar: 14, hand: "rh", start: 55.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 15, hand: "rh", start: 56.0, dur: 1.5, midi: 65, pitch: "F4", d: "quarter", dot: true },
    { bar: 15, hand: "lh", start: 56.0, dur: 2.0, midi: 41, pitch: "F2", d: "half" },
    { bar: 15, hand: "rh", start: 57.5, dur: 0.5, midi: 62, pitch: "D4", d: "eighth" },
    { bar: 15, hand: "rh", start: 58.0, dur: 2.0, midi: 59, pitch: "B3", d: "half" },
    { bar: 15, hand: "lh", start: 58.0, dur: 2.0, midi: 43, pitch: "G2", d: "half" },
    { bar: 16, hand: "rh", start: 60.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole" },
    { bar: 16, hand: "lh", start: 60.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole" },
  ],
};
